import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloseQuote1: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="close-quote-1, blockquote">
      <path
        d="M9.99263 9.5C9.99263 11.433 8.42728 13 6.49631 13C4.56535 13 3 11.433 3 9.5C3 7.567 4.56535 6 6.49631 6C8.42728 6 9.99263 7.567 9.99263 9.5ZM9.99263 9.5C10.2424 14.25 7.99473 16 4.99789 18M20.981 9.5C20.981 11.433 19.4157 13 17.4847 13C15.5538 13 13.9884 11.433 13.9884 9.5C13.9884 7.567 15.5538 6 17.4847 6C19.4157 6 20.981 7.567 20.981 9.5ZM20.981 9.5C21.2308 14.25 18.9832 16 15.9863 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </CentralIconBase>
  );
};

export default IconCloseQuote1;
